import React, { useMemo } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import { PAYPAL_ACCOUNTS_ACTIONS_KEYS } from '../translationKeys';

// Copia de containers/Payment/PayPal/screens/components/PayPalAccountsActions.js.
// El original llamaba goToScreen('paypalLinkAccount', { fromAccountsGrid: true });
// aquí la transición la resuelve el estado local vía `onAddAccount`.
const ADD_KEY = 'MDP_MetodosDePago_Icono_AgregarTarjeta';

export const PayPalAccountsActions = ({ assets, onAddAccount }) => {
  const { translationMapper } = useTranslation();
  const translatedTexts = useMemo(
    () => translationMapper(PAYPAL_ACCOUNTS_ACTIONS_KEYS),
    [translationMapper],
  );
  const title = translatedTexts.ADD_ACCOUNT_BUTTON;
  const addIcon = assets?.[ADD_KEY] || '';

  return (
    <div className="paypal-accounts-actions">
      <button
        type="button"
        className="paypal-accounts-actions__add"
        onClick={onAddAccount}
      >
        {addIcon ? (
          <img className="paypal-accounts-actions__add__icon" src={addIcon} alt="" />
        ) : (
          <span className="paypal-accounts-actions__add__icon" />
        )}
        <span className="paypal-accounts-actions__label">
          {title}
        </span>
      </button>
    </div>
  );
};

export default PayPalAccountsActions;
